/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MedicationReturn } from '../model/medicationReturn';
import { MedicationReturnLog } from '../model/medicationReturnLog';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MedicationReturnsService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns the medication return details on the RxNumber entered in the UI
     *     Sample Call      http://URL/api/MedicationReturn/GetMedicationReturnDetails?orgUnit&#x3D;ABING  &lt;param name&#x3D;\&quot;orgUnit\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;medicationReturn\&quot;&gt;&lt;/param&gt;
     * @param orgUnit 
     * @param medicationReturn 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationReturnsGetMedicationReturnDetails(orgUnit: string, medicationReturn: MedicationReturn, observe?: 'body', reportProgress?: boolean): Observable<MedicationReturn>;
    public medicationReturnsGetMedicationReturnDetails(orgUnit: string, medicationReturn: MedicationReturn, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationReturn>>;
    public medicationReturnsGetMedicationReturnDetails(orgUnit: string, medicationReturn: MedicationReturn, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationReturn>>;
    public medicationReturnsGetMedicationReturnDetails(orgUnit: string, medicationReturn: MedicationReturn, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling medicationReturnsGetMedicationReturnDetails.');
        }

        if (medicationReturn === null || medicationReturn === undefined) {
            throw new Error('Required parameter medicationReturn was null or undefined when calling medicationReturnsGetMedicationReturnDetails.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationReturn>(`${this.basePath}/api/MedicationReturn/GetMedicationReturnDetails`,
            medicationReturn,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the medication return logs for a given OrgUnitId within the selected timespan
     *     Sample Call      http://URL/api/MedicationReturn/GetMedicationReturnLog?startDate&#x3D;2016-1-1T12%3A30%3A00&amp;amp;endDate&#x3D;2017-2-1T12%3A30%3A00&amp;amp;orgUnit&#x3D;ABING  &lt;param name&#x3D;\&quot;orgUnit\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;startDate\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;endDate\&quot;&gt;&lt;/param&gt;
     * @param startDate 
     * @param endDate 
     * @param orgUnit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationReturnsGetMedicationReturnLog(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MedicationReturnLog>>;
    public medicationReturnsGetMedicationReturnLog(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MedicationReturnLog>>>;
    public medicationReturnsGetMedicationReturnLog(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MedicationReturnLog>>>;
    public medicationReturnsGetMedicationReturnLog(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling medicationReturnsGetMedicationReturnLog.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling medicationReturnsGetMedicationReturnLog.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling medicationReturnsGetMedicationReturnLog.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MedicationReturnLog>>(`${this.basePath}/api/MedicationReturn/GetMedicationReturnLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Inserts a new medication return log with the newly added medication returns collection
     *     Sample Call      http://URL/api/MedicationReturn/SaveMedicationReturns?orgUnit&#x3D;ABING  &lt;param name&#x3D;\&quot;orgUnit\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;medicationReturns\&quot;&gt;&lt;/param&gt;
     * @param orgUnit 
     * @param medicationReturns 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationReturnsSaveMedicationReturns(orgUnit: string, medicationReturns: Array<MedicationReturn>, observe?: 'body', reportProgress?: boolean): Observable<MedicationReturnLog>;
    public medicationReturnsSaveMedicationReturns(orgUnit: string, medicationReturns: Array<MedicationReturn>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationReturnLog>>;
    public medicationReturnsSaveMedicationReturns(orgUnit: string, medicationReturns: Array<MedicationReturn>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationReturnLog>>;
    public medicationReturnsSaveMedicationReturns(orgUnit: string, medicationReturns: Array<MedicationReturn>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling medicationReturnsSaveMedicationReturns.');
        }

        if (medicationReturns === null || medicationReturns === undefined) {
            throw new Error('Required parameter medicationReturns was null or undefined when calling medicationReturnsSaveMedicationReturns.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationReturnLog>(`${this.basePath}/api/MedicationReturn/SaveMedicationReturns`,
            medicationReturns,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
